import cadastroClienteRouter from '@/router/ptcRoutes/cadastroCliente.router';
import pedidos from '@/router/ptcRoutes/pedidos.router';
import notaFiscal from '@/router/ptcRoutes/notaFiscal.router';
import boleto from '@/router/ptcRoutes/boletos.router';
import produtos from '@/router/ptcRoutes/produtos.router';
import permissaoAcesso from './permissaoAcesso.router';
import dashboard from './dashboard.router';

export default [
  ...dashboard,
  ...permissaoAcesso,
  ...cadastroClienteRouter,
  ...pedidos,
  ...notaFiscal,
  ...boleto,
  ...produtos,
];
